import React, { Component } from "react";

import {View, Image, TouchableOpacity, Linking} from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, settingStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor } from "../theme/colors";
import DialogPrompt from "../components/DialogPrompt";
import Waiting from "../components/Waiting";
import DialogMessage from "../components/DialogMessage";
import { getError } from "../utils/utils";
import { deleteAccountRequest } from "../utils/api";
import { clearUsers } from "../database/UserDal";

export default class SettingScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showPrompt: false,
            showMessage: false,
            messageContent: '',
            messageTitle: '',
            waiting: false,
            promptMessage: ''
        }
        console.log(props)
    }

    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>تنظیمات</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={settingStyles.wraper}>
                <TouchableOpacity style={settingStyles.itemWraper} activeOpacity={0.5} onPress={() => {
                    this.setState({
                        showPrompt: true,
                        promptMessage: 'آیا نسبت به حذف حساب کاربری خود اطمینان دارید ؟'
                    })
                }}>
                    <Image source={icons['remove_account']} style={appStyles.toolbarIcon} />
                    <TextView>درخواست حذف حساب کاربری</TextView>
                </TouchableOpacity>

            </LinearGradient>
            <DialogPrompt
                show={this.state.showPrompt}
                message={this.state.promptMessage}
                approve='بله'
                cancel='خیر'
                onApprove={() => {
                    this.setState({
                        waiting: true,
                        showPrompt: false,
                    })
                    deleteAccountRequest((isConnect, response) => {
                        this.setState({
                            waiting: false
                        })
                        if (isConnect && response.isSuccess) {
                            this.setState({
                                showPrompt: false
                            }, () => {
                                this.logout();
                            })
                        } else {
                            this.setState({
                                showMessage: true,
                                messageContent: getError(response)
                            })
                        }
                    })


                }}
                onCancel={() => {
                    this.setState({
                        showPrompt: false
                    })

                }}
                onClose={() => {
                    this.setState({
                        showPrompt: false
                    })
                }} />
            <DialogMessage
                show={this.state.showMessage}
                title={this.state.messageTitle}
                message={this.state.messageContent}
                onClose={() => {
                    this.setState({
                        showMessage: false
                    })

                }} />
            <Waiting waiting={this.state.waiting} />
        </View>)
    }
    logout() {
        clearUsers();
        Linking.openURL('https://client.asandarman.ir');
    }
}
